import { minutes } from "$root/utils";

/**
 * How long any one request to the backend is allowed to take, and the ceiling on anything that
 * waits for a request to land (see `settlePendingWrites`). This app has genuinely long endpoints —
 * report generation, optimisations — so it is generous by design.
 *
 * It lives on its own so that a wait *for* a request is bounded by the same number as the request:
 * `auth-interceptors` reasons about this value against a Cognito access-token TTL, and a boundary
 * that gave up sooner than a request is allowed to take would abandon writes the transport had not
 * yet had its allotted chance to send.
 */
export const REQUEST_TIMEOUT = minutes(30);
